<template>
  <div class="w-100">
    <div class="col-md-12 mt-2">
      <div class="d-flex">
        <div class="px-0 d-flex me-4" style="place-items: center">
          <span class="fsize-16 me-3">Order Status</span>
          <select class="p-2 form-control" v-model="selected">
            <option v-for="data in listData" :key="data.id" :value="data.value">
              {{ data.value }}
            </option>
          </select>
        </div>
        <div>
          <button
            class="fw-bold p-2 btn bg-white shadow-sm bg-body rounded"
            @click="$router.push({ name: 'Cancel Order Settings' })"
          >
            Cancel Order Settings
            <img
              width="18"
              src="@/assets/sidebar/sidebar-icon-manage.svg"
              alt=""
            />
          </button>
        </div>
      </div>
      <WaitingPayment v-if="selected == 'Waiting Payment'" />
      <Paid v-else-if="selected == 'Paid'" />
      <Processed v-else-if="selected == 'Processed'" />
      <OnShipment v-else-if="selected == 'On Shipment'" />
      <Delivered v-else-if="selected == 'Delivered'" />
      <Canceled v-else-if="selected == 'Cancelled'" />
    </div>
  </div>
</template>

<script>
import WaitingPayment from "./routes/WaitingPayment.vue";
import Paid from "./routes/Paid.vue";
import Processed from "./routes/Processed.vue";
import OnShipment from "./routes/OnShipment.vue";
import Delivered from "./routes/Delivered.vue";
import Canceled from "./routes/Canceled.vue";
export default {
  components: {
    WaitingPayment,
    Paid,
    OnShipment,
    Delivered,
    Canceled,
    Processed,
  },
  data() {
    return {
      selected: "Waiting Payment",
      listData: [
        { value: "Waiting Payment", id: 1 },
        { value: "Paid", id: 2 },
        { value: "Processed", id: 3 },
        { value: "On Shipment", id: 4 },
        { value: "Delivered", id: 5 },
        { value: "Cancelled", id: 6 },
      ],
    };
  },
  watch: { 
      selected(value){
        this.$router.push(`/order/orders?status=${value}`)
      },
     '$route': {
        handler: function(value) {
          // prevent set query status to undefined
          if(value.path === "/order/orders" && value.query.status){
            this.selected = value.query.status
          }
        },
        deep: true,
      }
  },
  created(){
    if (this.$route.query.status){
      this.selected = this.$route.query.status
    }else{
      this.$router.push(`/order/orders?status=${this.selected}`)
    }
  }
};
</script>

<style scoped>
  .form-control {
    width: 150px;
  }
</style>
